import http from './http';

// 获取mqtt配置
export const getClientConfig = () => {
  return http({
    url: '/mqtt/client/config',
  });
};
